import React, { useState } from "react";
import ListingInvalidIcon from '../../../../../../src/designUtils/AmazonListing/ListingInvalidIcon.svg';
import ListingValidIcon from '../../../../../../src/designUtils/AmazonListing/ListingValidIcon.svg';


const groupByField = (issues) => {
  const map = new Map();
  issues.forEach((issue) => {
    const field = (issue.attributeNames && issue.attributeNames[0]) || "general";
    if (!map.has(field)) map.set(field, []);
    map.get(field).push(issue);
  });
  return Array.from(map.entries());
};

const AmazonProductListingUpdatePopup = ({ data, onUpdate, isListingValid, saving, mode }) => {
  const [activeTab, setActiveTab] = useState("total");

  if (!data) return <div>Loading...</div>;

  const { sku, status, submissionId, issues = [], updated_fields = [] } = data;

  const errorCount = issues.filter((i) => i.severity === "ERROR").length;
  const validFields = updated_fields.filter(u => u.status === "VALID");
  const validCount = validFields.length;
  const totalCount = errorCount + validCount;

  const grouped = groupByField(issues);

  return (
    <div className="validation-popup-container">

      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "20px", marginBottom: "20px" }}>

        <div className={`status-banner ${status === "INVALID" || status === "ERROR" ? "error-bg" : "success-bg"}`} style={{ flex: 1, margin: 0 }}>

          <h2 style={{ display: "flex", alignItems: "center", gap: "8px", margin: "0 0 10px 0" }}>
            {status === "INVALID" || status === "ERROR" ? (
              <>
                <img src={ListingInvalidIcon} alt="Invalid Icon" width="24" height="24" />
                Listing Invalid
              </>
            ) : (
              <>
                <img src={ListingValidIcon} alt="Valid Icon" width="24" height="24" />
                Listing Valid
              </>
            )}
          </h2>

          <p className="mb-1"><strong>SKU:</strong> {sku}</p>
          {submissionId && <p className="mb-0"><strong>Submission:</strong> {submissionId}</p>}
        </div>

        {mode !== "LIVE" && (
          <button
            className="btn btn-secondary btn-send-approval"
            disabled={!isListingValid || saving}
            // onClick={async () => {
            //   if (onUpdate) await onUpdate();
            // }}
            style={{ padding: "10px 24px", whiteSpace: "nowrap", height: "fit-content", fontWeight: "bold" }}
          >
            {saving ? "Updating..." : "Update Listing"}
          </button>
        )}
      </div>

      <div className="validation-tabs">
        <button
          className={`custom-tab-btn tab-total ${activeTab === "total" ? "active" : ""}`}
          onClick={() => setActiveTab("total")}
        >
          Total : {totalCount}
        </button>
        <button
          className={`custom-tab-btn tab-valid ${activeTab === "valid" ? "active" : ""}`}
          onClick={() => setActiveTab("valid")}
        >
          Valid : {validCount}
        </button>
        <button
          className={`custom-tab-btn tab-errors ${activeTab === "errors" ? "active" : ""}`}
          onClick={() => setActiveTab("errors")}
        >
          Errors : {errorCount}
        </button>
      </div>

      {(activeTab === "total" || activeTab === "errors") && issues.length > 0 && (
        <table className="custom-error-table">
          <thead>
            <tr>
              <th>Field</th>
              <th>Error Message</th>
              <th>Severity</th>
            </tr>
          </thead>
          <tbody>
            {grouped.map(([field, fieldIssues]) =>
              fieldIssues.map((issue, idx) => (
                <tr key={`${field}-${idx}`}>
                  {idx === 0 && (
                    <td
                      rowSpan={fieldIssues.length}
                      style={{ verticalAlign: "top", fontFamily: "monospace", fontWeight: "bold" }}
                    >
                      {field}
                      {fieldIssues.length > 1 && (
                        <span style={{ marginLeft: 6, background: "#fff1f0", color: "#cf1322", fontSize: 11, padding: "1px 6px", borderRadius: 10, border: "1px solid #ffa39e" }}>
                          {fieldIssues.length}
                        </span>
                      )}
                    </td>
                  )}
                  <td style={{ wordBreak: "break-word", whiteSpace: "normal", maxWidth: "500px" }}>
                    {issue.message}
                  </td>
                  <td style={{ color: issue.severity === "ERROR" ? "#CC0000" : "orange", fontWeight: "bold" }}>
                    {issue.severity}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      )}

      {(activeTab === "total" || activeTab === "valid") && validFields.length > 0 && (
        <div className="validated-values-card">
          <h6 className="text-dark fw-bold" style={{ fontSize: '14px' }}>Validated Values:</h6>
          <ul className="text-dark mb-0" style={{ paddingLeft: '20px', fontSize: '13px' }}>
            {validFields.map((f, idx) => (
              <li key={idx} className="mb-1" style={{ wordBreak: "break-all", overflowWrap: "break-word" }}>
                <strong>{f.field}:</strong> {JSON.stringify(f.value, null, 2)}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default AmazonProductListingUpdatePopup;